import { render, staticRenderFns } from "./jobPost.vue?vue&type=template&id=6a8feba4&scoped=true"
import script from "./jobPost.vue?vue&type=script&lang=js"
export * from "./jobPost.vue?vue&type=script&lang=js"
import style0 from "./jobPost.vue?vue&type=style&index=0&id=6a8feba4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8feba4",
  null
  
)

export default component.exports